import { createRequest } from "helpers/tools";

export const getActivityLog = async () => {
  return await createRequest({
    suffix: `user/activity-logs`,
    method: "get",
    handleError: false,
  });
};

export const getAuditLog = async () => {
  return await createRequest({
    suffix: `user/audit-logs`,
    method: "get",
    handleError: false,
  });
};
